import styled from 'styled-components';

import { breakpoint } from '../Helper/Breakpoints';
import { imagePositions } from './ImageWithText'

export const Image =styled.div`
    img{
        max-width:100%;
        height:auto;
        display:block;
    }
`;

export const Text = styled.div`
    background-color: #e6e6e6;
    text-align: left;
    padding: 20px 30px;
`;


export const ImageTextBlock = styled.div`
    display:flex;
    width:100%;
    flex-direction: ${({imagePosition}) => imagePosition === imagePositions.LEFT ? 'column' : 'column-reverse'};;
    
    @media ${breakpoint.md} {
      flex-direction: ${({imagePosition}) => imagePosition === imagePositions.LEFT ? 'row' : 'row-reverse'};
    }

    & > div{
        flex-basis: 50%;
    }
`;
